import { useRouter } from "next/router"
import { type PropsWithChildren } from "react"
import { Container, Stack } from "@octopus-energy/coral/atoms"
import { Page, PageLoader } from "@/components/organisms"
import { StoryblokCategories } from "@/features/storyblok/components/Categories"
import { StoryblokSearchBar } from "@/features/storyblok/components/SearchBar"
import {
    StoryblokLayout,
    type StoryblokLayoutProps,
} from "@/features/storyblok/components/StoryblokLayout"
import { type SbBlogHomePageStory } from "@/features/storyblok/types"
import { getParams } from "@/features/storyblok/utils/getParams"
import { BlogHeader } from "./BlogHeader"

type Props = PropsWithChildren<{
    css: StoryblokLayoutProps["css"]
    story?: SbBlogHomePageStory | null
    preview: boolean
    categoriesParams: {
        starts_with: string
        content_type: string
        sort_by?: string
    }
    searchParams: {
        starts_with: string
        content_type: string
        sort_by?: string
    }
}>

export function BlogHomeLayout({
    css,
    story,
    categoriesParams,
    searchParams,
    preview,
    children,
}: Props) {
    const categoriesOptions = getParams(preview, categoriesParams)
    const searchOptions = getParams(preview, searchParams)
    const router = useRouter()

    if (router.isFallback) {
        return <PageLoader />
    }

    return (
        <StoryblokLayout css={css}>
            <Page>
                <Stack flexDirection="column">
                    {story && <BlogHeader story={story} />}
                    <StoryblokCategories options={categoriesOptions} />

                    <Container marginY="sm">
                        <StoryblokSearchBar searchParams={searchOptions} />
                    </Container>
                    {children}
                </Stack>
            </Page>
        </StoryblokLayout>
    )
}

BlogHomeLayout.messages = [...StoryblokLayout.messages] as const
